import React, { Component } from "react";
// import AddDiner from "./AddDiner";
// import AddReservation from "./AddReservation";
import { Button, Image } from "react-bootstrap";
import AddWalkInWait from "../../../vendorDashboardComponents/seatingDashboard/AddWalkInWait";
import AddReservation from "../../../vendorDashboardComponents/seatingDashboard/AddReservation";

export class MainAddDinerReservation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedPAge: 1,
    };
  }

  onPageChange = (value) => (e) => {
    this.setState({
      selectedPAge: value,
    });
  };

  render() {
    return (
      <React.Fragment>
        <div className="d-flex align-items-center py-3 px-4 border-bottom">
          <span className="pr-3 cursor" onClick={this.props.onCloseModal}>
            <Image
              alt="Back"
              width="20px"
              src={require("../../../../assets/images/UserManagement/backIcon.svg")}
            />
          </span>
          <div className="f12-400 c_black">Add Diner</div>
        </div>
        {/* <div className="top-box-header-editdinner">
          <h4>
            {this.state.selectedPAge === 1
              ? "Add New Diner"
              : null || this.state.selectedPAge === 2
              ? "Add New Reservation"
              : null}
          </h4>
        </div> */}
        <div className="add-diner-reservation-topbar">
          <div className="add-diner-reservation-box">
            <div className="row">
              <div className="col-12 border-bottom">
                <div className="d-flex align-items-start">
                  <Button
                    variant="link"
                    className={`enAddOffersOPtion d-flex flex-column align-items-center mr-5 ${
                      this.state.selectedPAge === 1 ? "active" : ""
                    }`}
                    onClick={this.onPageChange(1)}
                  >
                    <Image
                      src={
                        this.state.selectedPAge === 1
                          ? require("../../../../assets/images/ActionImages/1/walkActive.svg")
                          : require("../../../../assets/images/ActionImages/1/walk.svg")
                      }
                      alt="View"
                      title="View"
                      fluid
                    />
                    <span className="active f12-400 d-block w-100 mb-2">
                      Walk-in/Wait
                    </span>
                  </Button>
                  <Button
                    variant="link"
                    className={`enAddOffersOPtion d-flex flex-column align-items-center ml-3 ${
                      this.state.selectedPAge === 2 ? "active" : ""
                    }`}
                    onClick={this.onPageChange(2)}
                  >
                    <Image
                      src={
                        this.state.selectedPAge === 2
                          ? require("../../../../assets/images/ActionImages/1/ReservationsActive.svg")
                          : require("../../../../assets/images/ActionImages/1/Reservations.svg")
                      }
                      alt="View"
                      title="View"
                      fluid
                    />
                    <span className="active f12-400 d-block w-100 mb-2">
                      Reservations
                    </span>
                  </Button>
                </div>
                {/* <div className="row">
                  <div className="col-3 col-sm-3 col-md-2 col-lg-2 col-xl-2 offset-2 offset-sm-2 offset-md-3 offset-lg-3 offset-xl-3">
                    <div className="d-flex">
                      <button
                        type="button"
                        className={
                          this.state.selectedPAge === 1
                            ? "main-button-size main-button-size-active"
                            : "main-button-size"
                        }
                        onClick={this.onPageChange(1)}
                      >
                        {this.state.selectedPAge === 1 ? (
                          <Image
                            className="button-image"
                            src={require("../../../../assets/images/ActionImages/chairwhite.svg")}
                            alt="seating"
                            title="Seating Button"
                          />
                        ) : (
                          <Image
                            className="button-image"
                            src={require("../../../../assets/images/ActionImages/chair.svg")}
                            alt="seating"
                            title="Seating Button"
                          />
                        )}
                      </button>
                    </div>
                    <p
                      className={
                        this.state.selectedPAge === 1
                          ? "bottom-small-active"
                          : "bottom-small"
                      }
                    >
                      Seating
                    </p>
                  </div>
                  <div className="col-4 col-sm-4 col-md-2 col-lg-2 col-xl-2 offset-2 offset-sm-2 offset-md-2 offset-lg-2 offset-xl-2">
                    <div className="d-flex justify-content-center">
                      <button
                        type="button"
                        className={
                          this.state.selectedPAge === 2
                            ? "main-button-size main-button-size-active"
                            : "main-button-size"
                        }
                        onClick={this.onPageChange(2)}
                      >
                        {this.state.selectedPAge === 2 ? (
                          <Image
                            className="button-image"
                            src={require("../../../../assets/images/seatingImages/reservationWhite.png")}
                            alt="Reservation"
                            title="Reservation Button"
                          />
                        ) : (
                          <Image
                            className="button-image"
                            src={require("../../../../assets/images/ActionImages/online-booking.svg")}
                            alt="Reservation"
                            title="Reservation Button"
                          />
                        )}
                      </button>
                    </div>
                    <p
                      className={
                        this.state.selectedPAge === 2
                          ? "bottom-small-active"
                          : "bottom-small"
                      }
                    >
                      Reservations
                    </p>
                  </div>
                </div> */}
                {/* <div className="row">
                <div className="col">
                  <h4 className="top-heading">
                    {this.state.selectedPAge === 1
                      ? "Add Diner"
                      : null || this.state.selectedPAge === 2
                      ? "Reservation"
                      : null}
                  </h4>
                </div>
              </div> */}
              </div>
              <div className="col-12">
                {this.state.selectedPAge === 1 ? (
                  // <AddDiner onCloseModal={this.props.onCloseModal} />
                  <AddWalkInWait />
                ) : null}
                {this.state.selectedPAge === 2 ? (
                  // <AddReservation onCloseModal={this.props.onCloseModal} />
                  <AddReservation />
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default MainAddDinerReservation;
